import { Product } from '@acorn-portal/shared/src/services/interface/Shared';
import { ReactNode } from 'react';
import CarShieldTick from '../../assets/shared/icons/base/car-shield-tick.svg?react';
import CarShieldTickLarge from '../../assets/shared/icons/base/car-shield-tick-large.svg?react';
import Car from '../../assets/shared/icons/base/car.svg?react';
import CarLarge from '../../assets/shared/icons/base/car-large.svg?react';
import Taxi from '../../assets/shared/icons/base/taxi.svg?react';
import TaxiLarge from '../../assets/shared/icons/base/taxi-large.svg?react';
import Van from '../../assets/shared/icons/base/van.svg?react';
import VanLarge from '../../assets/shared/icons/base/van-large.svg?react';

// Note, this is not a permanent solution - instead this will switch to a repo config driven solution in the future.
const icons: Record<'small' | 'large', Record<Product, ReactNode>> = {
	small: {
		[Product.TELEMATICS]: <CarShieldTick />,
		[Product.TAXI]: <Taxi />,
		[Product.COMMERCIAL_VEHICLE]: <Van />,
		[Product.PRIVATE_CAR]: <Car />,
		[Product.CARROT]: <CarShieldTick />,
		[Product.SHORT_TERM]: <Car />,
		[Product.STREET_COVER]: <Car />,
		[Product.SUBSCRIPTION]: <Car />,
		[Product.HOUSEHOLD]: <Car />,
	},
	large: {
		[Product.TELEMATICS]: <CarShieldTickLarge />,
		[Product.TAXI]: <TaxiLarge />,
		[Product.COMMERCIAL_VEHICLE]: <VanLarge />,
		[Product.PRIVATE_CAR]: <CarLarge />,
		[Product.CARROT]: <CarShieldTickLarge />,
		[Product.SHORT_TERM]: <CarLarge />,
		[Product.STREET_COVER]: <CarLarge />,
		[Product.SUBSCRIPTION]: <CarLarge />,
		[Product.HOUSEHOLD]: <CarLarge />,
	},
};

// Note, this is not a permanent solution - instead this will switch to a repo config driven solution in the future.
export const getVehicleIconByProduct = (product: Product, size: 'small' | 'large' = 'small'): ReactNode => {
	return icons[size][product] || <Car />;
};
